export default "__VITE_ASSET__353594e9__"